import Ad from "@components/Advertisement/Ad";
import Container from "@components/Container/Container";
import { GADataProps } from "@components/GAData/GAData";
import DTADescription from "@dta/components/DTADescription";
import DTAFooter from "@dta/components/DTAFooterComponents/DTAFooter";
import DTANominationsDescription from "@dta/components/DTANominationsDescription";
import DTAOrganiserDetails from "@dta/components/DTAOrganiserDetails";
import EventsAwardsHeader from "@events-awards/components/EventAwardsHeader";
import EventsAwardsNavigationBar from "@events-awards/components/EventsAwardsNavigationBarComponents/EventAwardsNavigationBar";
import LandingPageArticle from "@events-awards/components/LandingPageArticle";
import {
  AwardType,
  EventsAwardsLandingPageData,
} from "@events-awards/utils/types";
import { useInjectClientData } from "@hooks/useInjectClientData";

/**
 * Component to render DTA page
 */
const EventsAwardsDTAPageContent = ({
  articleProps,
  gaProps,
}: EventsAwardsLandingPageData & {
  gaProps: GADataProps;
}): React.ReactElement => {
  useInjectClientData({ gaProps });

  return (
    <div
      className="w-full"
      data-testid="events-awards-dta-page-content-component"
    >
      <EventsAwardsHeader />

      <Container>
        <EventsAwardsNavigationBar awardType={AwardType.DATA} />
      </Container>

      {articleProps ? (
        <div className="mb-6 bg-gray-150">
          <Container rootClassName="px-0 lg:px-3">
            <LandingPageArticle articleProps={articleProps} />
          </Container>
        </div>
      ) : null}

      <DTADescription />

      <div className="mt-1 bg-gray-150 py-8 md:px-3 md:px-6 lg:px-0">
        <Container rootClassName="flex flex-row justify-center items-center">
          <DTANominationsDescription />
        </Container>
      </div>

      <DTAOrganiserDetails />

      <DTAFooter />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default EventsAwardsDTAPageContent;
